
<div style="background-color: aqua !important; position: fixed;">
<particles  id= "particles"  [params]="myParams" [style]="myStyle" [width]="width" [height]="height"></particles>
</div>
<router-outlet></router-outlet>